import { render } from "./SpFooter.vue?vue&type=template&id=1015dd5a&scoped=true"
import script from "./SpFooter.vue?vue&type=script&lang=js"
export * from "./SpFooter.vue?vue&type=script&lang=js"

import "./SpFooter.vue?vue&type=style&index=0&id=1015dd5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1015dd5a"]])

export default __exports__